import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { DEFAULT_ROSTER_STATUSES, setActiveRosterStatuses } from "@/lib/rosterStatus";

const Ctx = createContext({ statuses: DEFAULT_ROSTER_STATUSES, reload: () => {}, save: async () => {} });

export function RosterStatusProvider({ children }) {
  const [statuses, setStatuses] = useState(DEFAULT_ROSTER_STATUSES);

  const apply = useCallback((list) => {
    const raw = Array.isArray(list) && list.length ? list : DEFAULT_ROSTER_STATUSES;
    const v = raw.map((s) => ({ ...s, label: s.label || s.labelIt, labelIt: s.labelIt || s.label }));
    setStatuses(v);
    setActiveRosterStatuses(v);
  }, []);

  const reload = useCallback(() => {
    api.get("/org/roster-statuses").then((r) => apply(r.data.statuses)).catch(() => {});
  }, [apply]);

  const save = useCallback(async (list) => {
    const r = await api.put("/org/roster-statuses", { statuses: list });
    apply(r.data.statuses);
    return r.data.statuses;
  }, [apply]);

  useEffect(() => { reload(); }, [reload]);

  return <Ctx.Provider value={{ statuses, reload, save }}>{children}</Ctx.Provider>;
}

export const useRosterStatuses = () => useContext(Ctx);
